import { makeAutoObservable } from 'mobx';

export interface BoardPageState {
  // 페이지네이션 상태
  page: number;
  pageSize: number;
  currentPage: number;
  
  // 필터 상태
  selectedFilter?: string;
  
  // 정렬 상태
  selectedSort?: string;
  
  // 검색 상태
  searchQuery?: string;
  
  // 기타 상태
  [key: string]: any;
}

class BoardStateStore {
  // 각 게시판별 상태 저장
  private boardStates: Record<string, BoardPageState> = {};
  private storageKey = 'boardStateStore.boardStates';

  constructor() {
    makeAutoObservable(this);
    this.hydrateFromStorage();
  }

  // 게시판 상태 저장
  saveBoardState(boardType: string, state: BoardPageState): void {
    this.boardStates[boardType] = { ...state };
    this.persistToStorage();
  }

  // 게시판 상태 복원
  getBoardState(boardType: string): BoardPageState | null {
    return this.boardStates[boardType] || null;
  }

  // 게시판 상태 초기화
  clearBoardState(boardType: string): void {
    delete this.boardStates[boardType];
    this.persistToStorage();
  }

  // 모든 상태 초기화
  clearAllStates(): void {
    this.boardStates = {};
    this.persistToStorage();
  }

  // 특정 필드만 업데이트
  updateBoardState(boardType: string, updates: Partial<BoardPageState>): void {
    if (this.boardStates[boardType]) {
      this.boardStates[boardType] = { ...this.boardStates[boardType], ...updates };
    } else {
      this.boardStates[boardType] = { ...updates } as BoardPageState;
    }
    this.persistToStorage();
  }

  private hydrateFromStorage(): void {
    try {
      if (typeof window === 'undefined') return;
      const raw = window.localStorage.getItem(this.storageKey);
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') {
        this.boardStates = parsed as Record<string, BoardPageState>;
      }
    } catch (e) {
      // ignore parsing errors
    }
  }

  private persistToStorage(): void {
    try {
      if (typeof window === 'undefined') return;
      window.localStorage.setItem(this.storageKey, JSON.stringify(this.boardStates));
    } catch (e) {
      // ignore quota or access errors
    }
  }
}

export const boardStateStore = new BoardStateStore();
